import {
    Component,
    EventEmitter,
    HostBinding,
    Input,
    Output
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'app-status-tri-state-checkbox',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: StatusTriStateCheckboxComponent,
            multi: true
        }
    ],
    templateUrl: './status-tri-state-checkbox.component.html',
    styleUrls: ['./status-tri-state-checkbox.component.scss']
})
export class StatusTriStateCheckboxComponent implements ControlValueAccessor {
    @Input() label = '';
    @Input() pendingValue: any = null;
    @Input() okValue: any = true;
    @Input() nokValue: any = false;
    @Input() state: any = null;
    @Output() stateChange = new EventEmitter<any>();
    @Output() select = new EventEmitter<any>();

    @HostBinding('attr.role') role = 'checkbox';
    @HostBinding('attr.tabindex') tabIndex = 0;

    disabled = false;

    @HostBinding('class.no-label') get noLabel(): boolean {
        return !this.label;
    }

    @HostBinding('class.state-checked') get isChecked(): boolean {
        return this.state === this.okValue;
    }

    @HostBinding('class.state-unchecked') get isUnchecked(): boolean {
        return this.state === this.nokValue;
    }

    @HostBinding('class.state-indeterminate') get isIndeterminate(): boolean {
        return this.state === this.pendingValue;
    }

    @HostBinding('attr.aria-checked') get ariaChecked(): string | boolean {
        if (this.state === this.pendingValue) {
            return 'mixed';
        }
        return this.state === this.okValue;
    }

    private onChangeCallback: (_: boolean | null) => void = () => {
    };
    private onTouchedCallback: () => void = () => {
    };

    writeValue(value: any): void {
        this.state = value;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onOkClick(event?: MouseEvent): void {
        event?.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.state = this.state === this.okValue ? this.pendingValue : this.okValue;
        this.notifyChanges();
    }

    onNokClick(event?: MouseEvent): void {
        event?.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.state = this.state === this.nokValue ? this.pendingValue : this.nokValue;
        this.notifyChanges();
    }


    private notifyChanges(): void {
        if (this.onChangeCallback) {
            this.onChangeCallback(this.state);
        }

        if (this.onTouchedCallback) {
            this.onTouchedCallback();
        }

        this.stateChange.emit(this.state);
        this.select.emit(this.state);
    }
}
